import axios from "axios";

const API_BASE = "https://dashboard.lono.co.in/api/finance";

// Financial Overview
export const getFinancialOverview = async (params = {}) => {
  const response = await axios.get(`${API_BASE}/overview`, { params });
  return response.data;
};

// Revenue APIs
export const getRevenues = async () => {
  const response = await axios.get(`${API_BASE}/revenues`);
  return response.data;
};

export const createRevenue = async (data) => {
  const response = await axios.post(`${API_BASE}/revenues`, data);
  return response.data;
};

export const updateRevenue = async (id, data) => {
  const response = await axios.put(`${API_BASE}/revenues/${id}`, data);
  return response.data;
};

// Expense APIs
export const getExpenses = async () => {
  const response = await axios.get(`${API_BASE}/expenses`);
  return response.data;
};

export const createExpense = async (data) => {
  const response = await axios.post(`${API_BASE}/expenses`, data);
  return response.data;
};

export const updateExpense = async (id, data) => {
  const response = await axios.put(`${API_BASE}/expenses/${id}`, data);
  return response.data;
};

// Fixed Cost APIs
export const getFixedCosts = async () => {
  const response = await axios.get(`${API_BASE}/fixed-costs`);
  return response.data;
};

export const createFixedCost = async (data) => {
  const response = await axios.post(`${API_BASE}/fixed-costs`, data);
  return response.data;
};

export const updateFixedCost = async (id, data) => {
  const response = await axios.put(`${API_BASE}/fixed-costs/${id}`, data);
  return response.data;
};

// Marketing Cost APIs
export const getMarketingCosts = async () => {
  const response = await axios.get(`${API_BASE}/marketing-costs`);
  return response.data;
};

export const createMarketingCost = async (data) => {
  const response = await axios.post(`${API_BASE}/marketing-costs`, data);
  return response.data;
};

export const updateMarketingCost = async (id, data) => {
  const response = await axios.put(`${API_BASE}/marketing-costs/${id}`, data);
  return response.data;
};

// Invoice APIs
export const getInvoices = async () => {
  const response = await axios.get(`${API_BASE}/invoices`);
  return response.data;
};

export const createInvoice = async (data) => {
  const response = await axios.post(`${API_BASE}/invoices`, data);
  return response.data;
};